'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');
import routes from './apis.routes';

require('../lib/swagger-ui/scripts/swagger-ui.js');
require('../lib/swagger-ui/scripts/modules/swagger-auth.min.js');

export class ApisComponent {
  constructor($http, $scope, $state, $anchorScroll) {
    window.swaggerOAuth.authorizeUrl = '/api/interactiveDoc/authorize';
    $scope.$state = $state;
	
    $http.get('/api/settings').then(res => { 
      window.swaggerOAuth.interactiveDocAppKey = res.data.apiInteractiveDocAppKey;
    });    
	
    $anchorScroll.yOffset = 70;
    $http.get(`/api/interactiveDoc/oftype/all`).then(response => {      
      $scope.swaggerObject = response.data;      
    });
  }
}

ApisComponent.$inject = ['$http', '$scope', '$state', '$anchorScroll'];

export default angular.module('syncplicityLoginApp.apis', [uiRouter])
  .config(routes)
  .component('apis', {
    template: require('./apis.html'),
    controller: ApisComponent,
    controllerAs: 'apisCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/apis/apis.component.js